/**
 * Web stub for Firebase Storage
 * All Storage operations should be guarded with Platform.OS !== 'web' checks
 */

const storageStub = {
  ref: () => ({
    child: () => ({
      putFile: () => Promise.resolve(),
      delete: () => Promise.resolve(),
      getDownloadURL: () => Promise.resolve(''),
    }),
    putFile: () => Promise.resolve(),
    delete: () => Promise.resolve(),
    getDownloadURL: () => Promise.resolve(''),
  }),
};

// Export as a function that returns the stub (mimics Firebase module behavior)
export default () => storageStub;
